import React from "react";
import * as S from "./styles";

const Input = ({
  label,
  inputName,
  registerFunction,
  errors,
  variant = "dark",
  ...props
}) => {
  if (!label || !inputName || !registerFunction) return null;

  const error = !!errors && errors[inputName];

  return (
    <div className="input-container">
      <S.InputContainer>
        <S.InputTextFieldContainer invalid={!!error} variant={variant}>
          <label htmlFor={inputName}>{label}</label>
          <input
            {...props}
            {...registerFunction(inputName)}
            aria-invalid={error ? "true" : "false"}
            type="text"
          />
        </S.InputTextFieldContainer>
      </S.InputContainer>

      {error && (
        <S.ErrorMessage variant={variant}>{error.message}</S.ErrorMessage>
      )}
    </div>
  );
};

export default Input;
